/**
 * Boot loader — the wordmark from the brand still: gray M, ice AI, white RKO.
 * A left-to-right wave is the wait, not a spinner.
 */
export function MairkoLoader({ className }: { className?: string }) {
	return (
		<div
			className={className ? `mairko-loader ${className}` : "mairko-loader"}
			role="img"
			aria-label="Loading"
		>
			<svg
				className="mairko-loader-mark"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 1000 202"
				fill="none"
				aria-hidden
			>
				<path
					className="mairko-loader-letter"
					style={{ animationDelay: "0ms" }}
					fill="#6B6B6B"
					d="M0.0 2.8 L0.0 199.0 L39.2 199.0 L39.4 91.5 L88.5 143.0 L137.8 91.5 L137.8 199.0 L176.9 199.0 L176.9 2.8 L164.8 2.8 L88.7 87.6 L12.3 2.8 Z"
				/>
				<path
					className="mairko-loader-letter mairko-loader-letter--ai"
					style={{ animationDelay: "90ms" }}
					fill="#60CFFB"
					fillRule="evenodd"
					d="M283.6 1.1 L203.3 198.8 L242.9 198.8 L283.6 98.4 Z M289.0 0.2 L289.0 98.6 L329.7 198.8 L369.7 198.8 Z"
				/>
				<path
					className="mairko-loader-letter mairko-loader-letter--ai"
					style={{ animationDelay: "180ms" }}
					fill="#60CFFB"
					d="M396.9 5.8 L396.9 198.8 L435.2 198.8 L435.2 5.8 Z"
				/>
				<path
					className="mairko-loader-letter"
					style={{ animationDelay: "270ms" }}
					fill="#FFFFFF"
					fillRule="evenodd"
					d="M478.9 5.8 L478.9 199.0 L517.4 199.0 L517.6 125.2 L536.0 125.2 L575.0 199.0 L618.6 199.0 L574.1 119.6 L574.5 119.0 L580.4 117.0 L587.3 113.3 L593.3 108.8 L598.1 104.0 L604.6 94.7 L607.8 87.8 L610.0 81.1 L611.9 69.4 L611.9 59.5 L610.9 51.5 L609.3 45.4 L606.3 37.4 L599.8 26.6 L592.5 18.8 L585.3 13.6 L575.6 9.1 L566.3 6.7 L558.5 5.8 Z M517.4 44.8 L554.4 44.6 L558.1 45.4 L561.8 47.2 L567.6 53.0 L569.5 56.9 L571.1 62.9 L570.6 71.8 L568.9 76.8 L566.9 80.0 L561.3 85.2 L558.1 86.7 L554.2 87.6 L517.6 87.6 Z"
				/>
				<path
					className="mairko-loader-letter"
					style={{ animationDelay: "360ms" }}
					fill="#FFFFFF"
					d="M644.4 5.8 L644.4 199.0 L683.1 198.8 L683.3 123.7 L734.4 199.0 L782.2 199.0 L714.0 101.2 L776.8 5.8 L731.6 5.8 L683.3 82.2 L683.1 6.1 Z"
				/>
				<path
					className="mairko-loader-letter"
					style={{ animationDelay: "450ms" }}
					fill="#FFFFFF"
					fillRule="evenodd"
					d="M883.4 3.7 L874.1 5.4 L864.2 8.2 L855.9 11.5 L845.3 17.1 L832.1 27.0 L824.8 34.6 L817.0 45.0 L813.8 50.4 L807.5 64.0 L804.7 72.7 L802.3 83.3 L801.0 93.9 L800.8 106.6 L801.6 116.6 L803.2 125.5 L805.5 134.5 L809.9 146.0 L814.0 154.2 L819.2 162.4 L825.9 170.9 L832.6 177.6 L844.9 186.9 L854.9 192.3 L861.6 195.1 L869.6 197.7 L883.0 200.5 L894.4 201.6 L906.3 201.6 L924.1 199.4 L934.2 196.8 L942.0 194.0 L951.5 189.5 L960.2 184.1 L967.3 178.5 L973.6 172.4 L978.8 166.3 L984.9 157.7 L989.6 149.0 L993.1 141.0 L996.3 131.1 L998.3 122.6 L1000.0 108.4 L1000.0 95.8 L998.1 80.5 L993.3 63.8 L990.7 57.5 L984.0 45.2 L978.6 37.6 L972.3 30.5 L960.4 20.3 L952.6 15.4 L944.0 11.0 L934.0 7.4 L923.9 4.8 L905.0 2.6 L895.7 2.6 Z M891.0 42.8 L905.9 42.4 L913.7 43.5 L925.4 47.2 L933.6 51.7 L941.6 58.4 L949.0 67.7 L954.4 78.7 L957.4 89.8 L958.5 100.6 L957.4 114.2 L954.4 125.2 L949.0 136.3 L941.8 145.4 L933.6 152.3 L923.9 157.5 L912.6 160.7 L905.9 161.6 L894.9 161.6 L889.5 160.9 L877.6 157.7 L868.3 152.9 L862.0 148.2 L857.5 143.6 L852.5 137.1 L846.4 125.0 L843.6 114.9 L842.5 106.2 L842.5 97.8 L843.6 89.1 L846.4 79.0 L852.5 66.8 L857.5 60.4 L862.0 55.8 L868.3 51.0 L879.3 45.6 Z"
				/>
			</svg>
		</div>
	);
}
